import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getSummary,
    getFunnel,
    getProviders,
    getPartners,
    getHistory,
    getUsers,
}

function getHistory(query) {
    return get('history', query)
}

function getSummary(query) {
    return get('summary', query)
}

function getFunnel(query) {
    return get('funnel', query)
}

function getProviders(query) {
    return get('providers', query)
}

function getPartners(query) {
    return get('partners', query)
}

function getUsers(query) {
    return get('users', query)
}

function get(path, query) {
    return new Promise((resolve) => {
        Superagent
            .get(`${HOST_API}/statistics/quotations/${path}`)
            .set('access', Storage.getItem('access'))
            .query(query)
            .end((err, res) => {
                resolve(res && res.body)
            })
    })
}
